import { z } from 'zod';
import type { SchedulingTypes } from '@/components/common/settings/custom-item-status/types';
import { datetimeFilter, picklistFilter } from './common/filters';
import {
  type DateOperator,
  type PicklistOperator,
  type StringOperator,
  stringOperators,
} from './common/operators';

export type ItemFilterOperator = DateOperator | PicklistOperator | StringOperator;

const schedulingTypes: SchedulingTypes[] = ['DONE', 'IN_PROGRESS', 'TO_DO'];

export const datetimeItemFilterSchema = z.object({
  createdAt: datetimeFilter,
  expectedFinishDateTime: datetimeFilter,
  expectedStartDateTime: datetimeFilter,
  latestFinishDateTime: datetimeFilter,
  doneDateTime: datetimeFilter,
  targetFinishDateTime: datetimeFilter,
  targetStartDateTime: datetimeFilter,
  updatedAt: datetimeFilter,
});

export const picklistItemFilterSchema = z.object({
  effortEstimate: picklistFilter,
  itemTypeId: picklistFilter,
  parentId: picklistFilter,
  ancestorId: picklistFilter,
  id: picklistFilter,
  loopId: picklistFilter,
  planId: picklistFilter,
  statusId: picklistFilter,
  teamId: picklistFilter,
  integrationId: picklistFilter,
});

export const stringItemFilterSchema = z.object({
  'descendant.statusItemStatusType': z
    .object({
      value: z.array(z.enum(schedulingTypes)).nullable().optional(),
      operator: stringOperators,
    })
    .optional(),
  name: z
    .object({
      value: z.string().optional(),
      operator: stringOperators,
    })
    .optional(),
  quickFilters: z
    .object({
      value: z.array(z.string()).optional(),
      operator: stringOperators,
    })
    .optional(),
});

export const itemFilterSearchSchema = z.object({
  ...datetimeItemFilterSchema.shape,
  ...picklistItemFilterSchema.shape,
  ...stringItemFilterSchema.shape,
});

export const isDateTimeFilterKey = (
  key: string,
): key is keyof typeof datetimeItemFilterSchema.shape => {
  return Object.keys(datetimeItemFilterSchema.shape).includes(key);
};

export const isPicklistFilterKey = (
  key: string,
): key is keyof typeof picklistItemFilterSchema.shape => {
  return Object.keys(picklistItemFilterSchema.shape).includes(key);
};

export const isStringFilterKey = (
  key: string,
): key is keyof typeof stringItemFilterSchema.shape => {
  return Object.keys(stringItemFilterSchema.shape).includes(key);
};
